export default __webpack_public_path__ + "static/media/buck.0264aaf3.svg";